export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MANAGER = 'ROLE_MANAGER';
export const ROLE_MARKETING_ADMIN = 'ROLE_MARKETING_ADMIN';
export const ROLE_MARKETING_MANAGER = 'ROLE_MARKETING_MANAGER';
